import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const getTodayInSaoPaulo = () => {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Sao_Paulo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).format(new Date());
};

const isSubscriptionExpired = user => {
  const company = user?.company;

  if (!company) {
    return false;
  }

  const isSuperUser =
    Boolean(user?.super) ||
    user?.profile === "super";

  if (isSuperUser) {
    return false;
  }

  if (company.status === false) {
    return true;
  }

  const dueDate = company.dueDate
    ? String(company.dueDate).slice(0, 10)
    : null;

  if (!dueDate) {
    return false;
  }

  return dueDate < getTodayInSaoPaulo();
};

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
  const { isAuth, loading, user } = useContext(AuthContext);

  if (loading) {
    return <BackdropLoading />;
  }

  if (!isAuth && isPrivate) {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: rest.location }
        }}
      />
    );
  }

  const currentPath = window.location.pathname;

  const subscriptionExpired =
    isAuth && isSubscriptionExpired(user);

  const isSubscriptionArea =
    currentPath === "/financeiro" ||
    currentPath.startsWith("/financeiro/");

  if (
    subscriptionExpired &&
    !isSubscriptionArea
  ) {
    return (
      <Redirect
        to={{
          pathname: "/financeiro",
          state: {
            paymentRequired: true,
            from: rest.location
          }
        }}
      />
    );
  }

  const routePath = rest.path;
  const isCurrentRoute =
    typeof routePath === "string" &&
    (rest.exact ? currentPath === routePath : currentPath.startsWith(routePath));

  if (isAuth && !isPrivate && isCurrentRoute) {
    const onboardingCompleted = Boolean(user?.company?.onboardingCompletedAt);
    return (
      <Redirect
        to={{
          pathname: onboardingCompleted ? "/tickets" : "/onboarding",
          state: { from: rest.location }
        }}
      />
    );
  }

  if (isAuth && isPrivate && user?.company) {
    const isOnboardingRoute =
      currentPath.startsWith("/onboarding");

    const afterOnboarding =
      sessionStorage.getItem("korax_after_onboarding");

    const isDirectJourneyRoute =
      (currentPath.startsWith("/korax-ia/treinamento") &&
        window.location.search.includes("experience=journey")) ||
      (currentPath.startsWith("/prompts") &&
        afterOnboarding === "/prompts");

    const onboardingCompleted =
      Boolean(user.company.onboardingCompletedAt);

    if (
      !onboardingCompleted &&
      !isOnboardingRoute &&
      !isDirectJourneyRoute
    ) {
      return <Redirect to="/onboarding" />;
    }

  }

  return <RouterRoute {...rest} component={Component} />;
};

export default Route;
